// src/components/FullBleed.jsx
import React, { useEffect, useRef, useState } from 'react';

export default function FullBleed({ bg, children }) {
  // 使用 ref 來計算內容高度，讓背景圖跟著內容
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState('100dvh');

  useEffect(() => {
    const updateHeight = () => {
      if (contentRef.current) {
        const height = contentRef.current.scrollHeight;
        setContentHeight(`${Math.max(height, window.innerHeight)}px`);
      }
    };

    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    // 也監聽 window resize
    window.addEventListener('resize', updateHeight);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  return (
    <div style={{ position: 'relative', minHeight: '100dvh', overflowY: 'auto', overflowX: 'hidden' }}>
      {/* 背景層：跟著內容滾動，高度與內容一致 */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: contentHeight,
          backgroundImage: `url(${bg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          zIndex: -1,
        }}
      />
      {/* 前景層：放實際內容；允許頁面滾動 */}
      <div ref={contentRef} style={{ position: 'relative', minHeight: '100%' }}>
        {children}
      </div>
    </div>
  );
}
